<template>
  <div id="app">
    <headerSection />
    <transition name="fade" mode="out-in">
      <router-view id="routerView" />
    </transition>
    <footerSection />
  </div>
</template>
<script>
import headerSection from "@/components/layout/HeaderSection.vue";
import footerSection from "@/components/layout/FooterSection.vue";
export default {
  data() {},
  components: {
    headerSection,
    footerSection
  }
};
</script>

<style lang="scss">
#app {
  padding: 0 15px;
  overflow-x: hidden;
  max-width: 1500px;
  margin: 0 auto;
  @include media-md {
    padding: 0 50px;
  }
}
#routerView {
  margin-top: $headerHeight;
  padding-top: 10px;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
